import {
  NavigationAutos,
  NavigationHistory,
  NavigationHistoryPathType,
  Transaction,
} from "../types";
import { LoadingStatus } from "shared/constants";

export interface NavigationState {
  autos: {
    data?: NavigationAutos;
    loadingStatus?: LoadingStatus;
  };
  history: {
    data?: NavigationHistory;
    loadingStatus?: LoadingStatus;
  };
  clientEventsPathFilters: ClientEventHistoryPathFilters;
  clientEvents: {
    fuel: {
      data?: Transaction[];
      loadingStatus?: LoadingStatus;
    };
    road: {
      data?: Transaction[];
      loadingStatus?: LoadingStatus;
    };
    service: {
      data?: Transaction[];
      loadingStatus?: LoadingStatus;
    };
  };
}

export type ClientEventHistoryPathFilter =
  | HistoryTypeTransaction
  | NavigationHistoryPathType;

export type ClientEventHistoryPathFilters = ClientEventHistoryPathFilter[];

export enum DriverStopPeriod {
  less15min,
  more15min,
  more8hours,
}

export type DriverStop = {
  time: number;
  count: number;
};

export type HistoryTypeTransaction = "Fuel" | "Service";

export type TransactionWithType = Transaction & {
  type: HistoryTypeTransaction;
};
